const numberFormatter = new Intl.NumberFormat("de-DE");
const decimalFormatter = new Intl.NumberFormat("de-DE", {
  maximumFractionDigits: 2
});

export function formatNumber(value) {
  if (value === null || typeof value === "undefined" || value === "") {
    return "-";
  }
  const number = Number(value);
  return Number.isNaN(number) ? value : numberFormatter.format(number);
}

export function formatDecimal(value) {
  if (value === null || typeof value === "undefined" || value === "") {
    return "-";
  }
  const number = Number(value);
  return Number.isNaN(number) ? value : decimalFormatter.format(number);
}

export function formatPercentage(value, fractionDigits = 0) {
  if (value === null || typeof value === "undefined" || value === "") {
    return "-";
  }
  const number = Number(value);
  if (Number.isNaN(number)) {
    return value;
  }
  return `${new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(number)} %`;
}

export function formatNumberWithPercentage(value) {
  return `${formatNumber(value)} (100%)`;
}
